// extracted by mini-css-extract-plugin
module.exports = {"spinner":"style_spinner__haD8U","spin":"style_spin__GMHN5"};